module.exports = __webpack_public_path__ + "eaf7a634991212f4b06b2a6761bd1449.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/ja.json
// module id = 1084
// module chunks = 0